import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        visit: {
            type: '',
            branch: '',
            specialist: '',
            date: '',
            slots: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            consents: '',
        },
        firstView: '',
        slotTime: '',
        confirmation: false,
        showMessage: false,
        message: {
            type: '',
            text: ''
        }

    },
    mutations: {
        setVisitProperty(state, payload) {
            Vue.set(state.visit, payload.index, payload.value);
        },
        setFirstView(state, value) {
            state.firstView = value;
        },
        setConfirmation(state, value) {
            state.confirmation = value;
        },
        setSelectedTimeSlot(state, value) {
            state.slotTime = value;
        },
        showMessage(state, value) {
            state.showMessage = value
        }
    },
    actions: {
        setMessage({commit, state}, payload) {
            commit('showMessage', true);
            state.message = payload;

            setTimeout(() => {
                commit('showMessage', false);
                state.message = {type: '', text: ''};
            }, 4000);
        }
    },
    getters: {
        // gettery
    }
})